export default "__VITE_ASSET__20nmFMFf__"